import { render, staticRenderFns } from "./TheUserEdit.vue?vue&type=template&id=036952a0&"
import script from "./TheUserEdit.vue?vue&type=script&lang=js&"
export * from "./TheUserEdit.vue?vue&type=script&lang=js&"
import style0 from "./TheUserEdit.vue?vue&type=style&index=0&id=036952a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports